import ProfileEducation from './ProfileEducation.component';

export default ProfileEducation;
